export default __webpack_public_path__ + "static/media/icon-check.ee1b4280.svg";